import { Outlet, useLocation } from 'react-router';
import { Box, useTheme } from '@mui/material';
import { useEffect } from 'react';
import { trackPageView } from '@/services/analyticsService';
import AppNavDrawer from './AppNavDrawer';
import InsightsJobWatcher from '../globalPrompts/insights/InsightsJobWatcher';

const AppLayout: React.FC = () => {
    const theme = useTheme();
    const location = useLocation();

    // Track page views on route changes
    useEffect(() => {
        trackPageView();
    }, [location.pathname, location.search]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', height: '100vh' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, borderRight: '1px solid', borderColor: 'divider' }}>
                <AppNavDrawer />
                <InsightsJobWatcher />
            </Box>
            <Box sx={{ flex: 1, width: '100%', overflow: 'auto', bgcolor: theme.palette.gray[10], height: '100%' }}>
                <Outlet />
            </Box>
        </Box>
    );
};

export default AppLayout;
